export default {
  dataTypes: [
    '图片', '视频', '语音', '文本'
  ],
  labelState: ['origin', 'modify', 'check', 'correct'],
  taskState: [{ name: '待接收', state: 'origin' },
    { name: '待拆分', state: 'already_accept' },
    { name: '已拒绝', state: 'already_deny' },
    { name: '待分配', state: 'waiting_assign' },
    { name: '待标注', state: 'waiting_annotate' },
    { name: '标注中', state: 'doing_annotation' },
    { name: '已标注', state: 'already_annotation' },
    { name: '已合并', state: 'merge' }],
  subTaskState: [{ name: '待分配', state: 'origin' },
    { name: '待标注', state: 'waiting_annotate' },
    { name: '标注中', state: 'doing_annotation' },
    { name: '已标注', state: 'already_annotation' },
    { name: '已合并', state: 'merge' }],
  menuList: [
    {
      name: '账号信息',
      route: 'account',
      key: '1'
    },
    {
      name: '数据管理',
      key: '2',
      children: [
        {
          name: '数据',
          route: 'dataItem',
          key: '2-1'
        },
        {
          name: '数据集',
          route: 'dataSet',
          key: '2-2'
        },
        {
          name: '数据上传',
          route: 'dataUpload',
          key: '2-3'
        },
        {
          name: '数据下载',
          route: 'dataDownload',
          key: '2-4'
        },
        {
          name: '数据属性',
          route: 'dataAttr',
          key: '2-5'
        },
        {
          name: '标签管理',
          route: 'tagManage',
          key: '2-6'
        }
      ]
    },
    {
      name: '任务管理',
      key: '3',
      children: [
        {
          name: '任务列表',   //  运营端管理员
          route: 'operateList',
          key: '3-1'
        },
        {
          name: '任务列表',   //  服务商管理员
          route: 'listForManager',
          key: '3-2'
        },
        {
          name: '任务列表',   //  服务商标注员
          route: 'listForAnnotator',
          key: '3-3'
        },
        {
          name: '上传列表',   //  服务商标注员  上传列表
          route: 'uploadList',
          key: '3-4'
        },
        {
          name: '任务列表',   //  服务质检员
          route: 'listForInspector',
          key: '3-5'
        },

        {
          name: '标注合并',   //  运营端管理员  合并任务列表
          route: 'mergeList',
          key: '3-6'
        },

        // {
        //   name: '筛选任务',   //  运营端管理员
        //   route: 'taskFilter',
        //   key: '3-7'
        // },
        
        // {
        //   name: '任务列表',   //发布任务  运营端管理员
        //   route: 'taskRelease',
        //   key: '3-1'
        // },
        // {
        //   name: '任务列表',  //接收任务  服务端管理员
        //   route: 'taskReception',
        //   key: '3-2'
        // },
        // {
        //   name: '任务列表',  //接收任务   服务端标注员
        //   route: 'myTask',
        //   key: '3-3'
        // },
        // {
        //   name: '任务列表',  //接收任务   服务端质检员
        //   route: 'auditTask',
        //   key: '3-4'
        // },

        // {
        //   name: '任务列表',  //分配任务
        //   route: 'taskAllocation',
        //   key: '3-3'
        // },
        // {
        //   name: '任务列表', //标注任务
        //   route: 'myTask',
        //   key: '3-4'
        // },


        // {
        //   name: '任务详情', //标注任务
        //   route: 'taskDetail',
        //   key: '3-5'
        // }
        /* {
          name: '审核任务',
          route: 'auditTask',
          key: '3-5'
        } */
      ]
    },
    {
      name: '组织管理',
      key: '4',
      children: [
        {
          name: '账号管理',
          route: 'userManage',
          key: '4-1'
        },
        {
          name: '团队管理',
          route: 'teamManage',
          key: '4-2'
        },
        {
          name: '公司管理',
          route: 'companyManage',
          key: '4-3'
        }
      ]
    }
  ],
  permissionDic: {
    // 1用于测试 2-5本平台前端不用
    /* 
     1 超级管理员
     2 权限系统角色
     3 运维监控角色
     4 测试角色
     5 默认角色
    
    */

    1: ['account', 'dataItem', 'dataSet', 'dataUpload', 'dataDownload', 'dataAttr', 'tagManage', 'taskRelease', 'userManage', 'teamManage', 'taskReception', 'taskAllocation', 'myTask', 'subTask', 'auditTask'],
    2: ['account'],
    3: ['account'],
    4: ['account'],
    5: ['account'],
    /*
      7 数据公司管理员
      8 数据公司团队管理员
      9 数据公司上传员
      10 数据公司下载员
      11 数据公司查看员
      12 数据公司数据专员
    */
    7: ['account', 'dataItem', 'dataSet', 'itemList', 'dataUpload', 'dataDownload', 'dataAttr', 'tagManage', 'userManage', 'teamManage','operateList','taskDetail','labelDetail','mergeList','sievingDetail'],
    8: ['account', 'dataItem', 'dataSet', 'itemList', 'dataUpload', 'dataDownload', 'dataAttr', 'tagManage', 'taskRelease', 'userManage','operateList','taskDetail','labelDetail','mergeList'],
    9: ['account', 'dataItem', 'dataUpload'],
    10: ['account', 'dataItem', 'dataSet', 'itemList', 'dataDownload'],
    11: ['account', 'dataItem'],
    12: ['account', 'dataItem', 'dataSet', 'itemList', 'dataUpload', 'dataDownload', 'dataAttr', 'tagManage', 'taskRelease','operateList','taskDetail','labelDetail','mergeList'],
    /**
     * 13 标注公司管理员
     * 14 标注公司团队管理员
     * 15 标注公司标注员 (标注公司标注审核员 旧)  标注公司标注审核员
     * 
     * 16 测试平台管理员
     * 
     * 17  标注公司标注员
     * 18  标注公司质检员
     * 
     */
    13: ['account', 'taskReception', 'taskAllocation', 'subTask', 'userManage', 'teamManage',,'listForManager','taskDetail','labelDetail'],
    14: ['account', 'taskReception', 'taskDetail','taskAllocation','userManage','listForManager','taskDetail','labelDetail'],
    15: ['account', 'myTask', 'subTask', 'auditTask'],
    16:[],
    17:['listForAnnotator','taskDetail','labelDetail','uploadList','sievingDetail'],
    18:['listForInspector','taskDetail','labelDetail','inspectDetail']
  },
  btnPerm: {
    dataset: {
      add: ['8', '12'],
      edit: ['7', '8', '10', '12'],
      delete: ['7', '8', '10', '12']
    },
    upload: {
      add: ['8', '9', '12'],
      delete: ['7', '8', '9', '12']
    },
    download: {
      add: ['8', '10', '12'],
      delete: ['7', '8', '10', '12']
    },
    dataAttr: {
      add: ['8', '12']
    },
    tag: {
      add: ['8', '12']
    }
  }
}
